import { Button, DownloadIcon, TextLink } from "@don/design-system";

/**
 * Where the Console sends someone for the recorder (issue 260). The one place either URL is
 * spelled (`tests/recorder-links.test.tsx` refuses a second).
 *
 * `/download` redirects to the visitor's platform installer on the landing site (issue 259),
 * so the Console does no user-agent sniffing. `/getting-started` is the setup guide.
 */
export const RECORDER_DOWNLOAD_URL = "https://almostdon.ai/download";
export const GETTING_STARTED_URL = "https://almostdon.ai/getting-started";

/** The setup guide, in a new tab. Under the download, and under the code in the code panel. */
export function GettingStartedLink() {
  return (
    <span style={{ fontSize: "var(--type-small-size)" }}>
      <TextLink href={GETTING_STARTED_URL} newTab data-recorder-guide="">
        Getting started
      </TextLink>
    </span>
  );
}

/** The download as a secondary button, for `EmptyState`'s `secondary`. */
export const DOWNLOAD_BUTTON = {
  as: "a",
  href: RECORDER_DOWNLOAD_URL,
  children: "Download the recorder",
  iconLeft: <DownloadIcon />,
  "data-recorder-download": "",
} as const;

/**
 * The Team header's `Download the recorder`: the download's label and icon, but it opens the
 * setup guide in a new tab, which links the installer itself (owner request 2026-10-12).
 */
export function GuideDownloadButton() {
  return (
    <Button
      variant="secondary"
      {...DOWNLOAD_BUTTON}
      href={GETTING_STARTED_URL}
      newTab
    />
  );
}
